import { useMemo } from 'react';
import { Outlet } from 'react-router-dom-v5-compat';
import { UserHasRoleAndSubscription } from '../../../../../role-based-route';
import { PagingContextProvider } from '../../../../../contexts/paging-context';
import { useUserSetting } from '../../../../../hooks/use-user-setting';
import { UserSettings } from '../../../../../enums/user-settings/user-settings';
import { PAGE_SIZE_250 } from '../../../../../services/pagination-service';
import { TransferOrdersGridContextProvider } from '../../data/transfer-orders-context';

export const TransferOrdersLayout = () => {
  const userSetting = useUserSetting(UserSettings.transferOrdersGridPageSize.settingName);
  const userPageSize = useMemo(() => parseInt(userSetting || PAGE_SIZE_250, 10), [userSetting]);

  return (
    <UserHasRoleAndSubscription>
      <PagingContextProvider page={1} pageSize={userPageSize}>
        <TransferOrdersGridContextProvider>
          <Outlet />
        </TransferOrdersGridContextProvider>
      </PagingContextProvider>
    </UserHasRoleAndSubscription>
  );
};
